import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Site } from '@classes/site';
import { WaitingTime } from '@classes/waiting-time';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { SitesService } from '@services/sites.service';
import { UiService } from '@services/ui.service';
import { WaitingTimesService } from '@services/waiting-times.service';

@Component({
  selector: 'app-waiting-time-edit',
  templateUrl: './waiting-time-edit.component.html',
  styleUrls: ['./waiting-time-edit.component.scss']
})
export class WaitingTimeEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() waitingTime: WaitingTime;
  @Input() sitesAlreadyTaken: Site[];

  sites: Site[];

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private waitingTimesSrv: WaitingTimesService,
    private sitesSrv: SitesService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSub();
  }

  initSub(): void {
    this.isLoading = true;
    this.sitesSrv.getList().subscribe(sitesFromSrv => {
      this.sites = sitesFromSrv.filter((el) => {
        return !this.sitesAlreadyTaken.some((f) => {
          return f.id === el.id;
        });
      });

      this.isLoading = false;
      this.initForm();
    });
  }


  onSubmit(): void {
    this.isLoading = true;
    if (this.waitingTime) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const holidayCopy: WaitingTime = JSON.parse(JSON.stringify(this.waitingTime));
    holidayCopy.site = this.editForm.value.site;
    holidayCopy.minutes = this.editForm.value.minutes;
    holidayCopy.price = this.editForm.value.price;
    holidayCopy.nonHourlyPrice = this.editForm.value.nonHourlyPrice;

    this.waitingTimesSrv.put(holidayCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.waitingTime = new WaitingTime(
      this.editForm.value.site,
      this.editForm.value.minutes,
      this.editForm.value.price,
      this.editForm.value.nonHourlyPrice
    );

    this.waitingTimesSrv.post(this.waitingTime)
      .subscribe(
        () => this.isLoading = false,
        () => this.waitingTime = null
      );
  }

  private initForm(): void {
    let site: Site = null;
    let minutes = null;
    let price = null;
    let nonHourlyPrice = null;

    if (this.waitingTime) {
      site = this.waitingTime.site;
      minutes = this.waitingTime.minutes;
      price = this.waitingTime.price;
      nonHourlyPrice = this.waitingTime.nonHourlyPrice;

      this.sites.push(site);

      this.sites = this.sites.sort((a, b) => a.name.localeCompare(b.name));
    }

    this.editForm = this.fb.group({
      site: [site, Validators.required],
      minutes: [minutes, [Validators.required, Validators.min(1)]],
      price: [price, [Validators.required, Validators.min(0)]],
      nonHourlyPrice: [nonHourlyPrice, [Validators.min(0)]]
    });
  }
}
